







































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import  TeacherInput from '@/store/models/maintain/teacherInput'
@Component({})
export default class TeacherManager extends VueBase {
	loading: boolean = false
	finished: boolean = false
	error: boolean = false
	totalCount: number = 0
	teacherList: Array<any> = []
	searchForm: TeacherInput = new TeacherInput()
    coachName: string = ''
	onClickLeft() {
		window.history.go(-1)
	}

	// 页面初次加载
	async onLoad() {
		this.error = false
        console.log(this.finished)
        if(this.finished==true) return
		await this.searchTeacherList()
        
	}
	// 查询数据
	async searchTeacherList() {
		await ajax
			.get('/Teacher/GetTeacherList', { params: this.searchForm })
			.then((rep) => {
				this.teacherList.push(...rep.data.result)
                this.finished = true
			})
			.catch(() => {
				this.error = false
			})
			.finally(() => {
				this.loading = false
			})
                        
	}

    async onSearch() {
        this.searchForm.coachName = this.coachName
        this.teacherList = []
        this.error = false
        await this.searchTeacherList()
    }
    onCancel(){

    }
}
